import { Card, CardContent, CardTitle } from "@/shared/ui/card";
import { Network } from "lucide-react";
import { CircuitTaggingType, L2VPNCircuitMapping, L2VPNCircuitRecord } from "@/shared/types/l2vpnTypes";
import { Badge } from "@/shared/ui/badge";

interface AccountL2VPNCircuitCardProps {
  record: L2VPNCircuitRecord;
}

const AccountL2VPNCircuitCard = ({
  record
}: AccountL2VPNCircuitCardProps) => {
  return (
    <Card className="border border-border">
      <CardContent className="flex flex-col gap-4 p-4">
        {/* Header Section */}
        <div className="flex flex-col w-full">
          <div className="flex flex-row justify-between w-full mb-4">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-background rounded-lg flex items-center justify-center border">
                <Network className="h-6 w-6" />
              </div>
              <div>
                <CardTitle className="text-lg">{record.circuitName ?? 'Unnamed Circuit'}</CardTitle>
                <div className="flex flex-row items-center space-x-2">
                  <Badge variant="default" className="border">Allocated Customer VLANs: {record.allocatedCustomerVlanRange}</Badge>
                  <Badge variant="default" className="border">Allocated Service VLANs: {record.allocatedServiceVlanRange}</Badge>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start space-y-2">
            {record.mappings?.length > 0 ? (
              <>
                {Object.entries(
                  record.mappings.reduce((acc, mapping) => {
                    acc[mapping.taggingType] = acc[mapping.taggingType] || [];
                    acc[mapping.taggingType].push(mapping);
                    return acc;
                  }, {} as Record<CircuitTaggingType, L2VPNCircuitMapping[]>)
                ).map(([taggingType, mappings]) => (
                  <div key={taggingType} className="flex flex-col items-start space-y-2 w-full">
                    <span className="text-sm font-medium">
                      Tagging Type: <Badge variant="default" className="border">
                        {taggingType === CircuitTaggingType.QINQ ? 'Q-in-Q' : 'Single'}
                      </Badge>
                    </span>
                    {mappings.map((mapping, index) => (
                      <div key={`${index}`} className="border border-border flex flex-row items-center justify-between rounded-lg p-4 w-full">
                        <p className="text-sm font-medium">Terminal ID: {mapping.userTerminalId}</p>
                        <p className="text-sm font-medium">Customer VLANs: {mapping.customerVlans.join(', ')}</p>
                        <p className="text-sm font-medium">Service VLAN: {mapping.serviceVlan}</p>
                      </div>
                    ))}
                  </div>
                ))}
              </>
            ) : (
              <span className="text-sm font-medium italic text-red-500">No ranges are used from this circuit in a terminal yet.</span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AccountL2VPNCircuitCard; 